export const UPLOAD_DOCUMENT = "api/v1/doctor/upload-document";
export const GET_PATIENT_DOCTOR_DOCUMENTS = "user/get-document-rev1";
export const GET_Rx_ERx_PRESCRIPTION = "api/v2/doctor/get_past_prescriptions";
export const SHARE_PRESCRIPTION = "doctor/share-e-prescription";
export const SHARE_MANUAL_PRESCRIPTION =
  "doctor/upload-manual-prescription-rev1";
